import { BASE_TEXTS } from '../common/textMsg';

/**
 * Log error if it's not https error.
 * By the real exception throws text errors
 * 
 * @throws If the error is API error throws **error** field of response
 *    otherwise throws def API 
 * 
 * @example
 * 
 * try {
 *    const resp = await fetch('/api/call')
 *    if (!resp.ok) throw resp
 * } catch (exception) {
 *    await preprocessApiException(exception);
 * }
 * 
 * // make sure you add **await** keyword
 */
export async function preprocessApiException(exception) {
   if (exception.name === 'AbortError') throw exception;
   throw (await getTextOfApiException(exception));
}

export async function getTextOfApiException(exception) {
   if (typeof exception === 'string') {
      return exception;
   }

   if ('ok' in exception) {
      const err = (await exception.json()).error;
      console.error(err);
      return err.message;
   }

   console.error(exception);
   return BASE_TEXTS.NetworkError;
}
